import { Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { FooterContainerComponent } from '@kempower-nx-workspace/layout-templates';
import { BrandingService, GetBrandingResult } from '../../data-access/branding.service';

@Component({
    selector: 'rl-core-receipt-footer',
    standalone: true,
    imports: [CommonModule, FooterContainerComponent],
    templateUrl: './receipt-lookup-footer.component.html',
    styleUrl: './receipt-lookup-footer.component.scss',
})
export class ReceiptLookupFooterComponent {
    readonly #brandingService = inject(BrandingService);

    // Keep these - they'll work with the shared service instance
    brandingState = toSignal(this.#brandingService.brandingState$, {
        initialValue: { loading: false } as GetBrandingResult,
    });

    supportContact = computed(() => {
        this.brandingState();
        return this.#brandingService.getSupportContact() || '';
    });
}
